import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Flame, Heart, User, Eye } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BottomNav({ active }) {
  const navigate = useNavigate();
  const { token, user } = useAuth();
  const [likeCount, setLikeCount] = useState(0);
  const pollRef = useRef(null);

  const fetchLikeCount = useCallback(async () => {
    if (!token || !user?.is_paid) return;
    try {
      const { data } = await axios.get(`${API}/likes/received`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLikeCount(data.count);
    } catch (e) {
      // silently fail
    }
  }, [token, user]);

  useEffect(() => {
    fetchLikeCount();
    pollRef.current = setInterval(fetchLikeCount, 15000);
    return () => clearInterval(pollRef.current);
  }, [fetchLikeCount]);

  const navItems = [
    { id: 'discover', icon: Flame, label: 'Discover', path: '/app' },
    { id: 'likes', icon: Eye, label: 'Likes', path: '/app/likes', badge: likeCount },
    { id: 'matches', icon: Heart, label: 'Matches', path: '/app/matches' },
    { id: 'profile', icon: User, label: 'Profile', path: '/app/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bottom-nav z-50">
      <div className="flex items-center justify-around h-20 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = active === item.id;
          
          return (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center gap-1 px-5 py-2 rounded-xl transition-colors ${
                isActive
                  ? 'text-rose-500'
                  : 'text-zinc-500 hover:text-zinc-300'
              }`}
            >
              <div className="relative">
                <Icon className={`w-6 h-6 ${isActive ? 'fill-current' : ''}`} />
                {item.badge > 0 && (
                  <span className="absolute -top-2 -right-3 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold flex items-center justify-center">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
